export function Divider() {
  return (
    <div className="flex items-center gap-3 my-5">
      <div className="flex-1 h-px bg-[#1e3248]" />
      <span className="text-xs text-[#6b7785] uppercase tracking-wider select-none">
        or
      </span>
      <div className="flex-1 h-px bg-[#1e3248]" />
    </div>
  );
}
